import { cn } from '@/lib/utils'

/**
 * Skeleton component from shad/cn, customized for Doss.
 *
 * By default, it uses the skeleton-onlight color, because most of the product is on a light background.
 * If you need to use it on a dark background, you can use the skeleton-ondark color, see the example in BreadcrumbSkeleton.tsx.
 *
 * Added on July 10, 2024
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded bg-skeleton-onlight', className)} {...props} />
}

export { Skeleton }
